module.exports = __webpack_public_path__ + "img/image_header-round-parts_02.e2c83a5c.svg";